import { useLocationContext } from "../Context/LocationContext";
import { AddressModal } from "./AddressModal";

const AddressModalContainer = () => {
  const { addressModalOpen, setAddressModalOpen, location, setLocation } =
    useLocationContext();

  return (
    <AddressModal
      isOpen={addressModalOpen}
      onClose={() => setAddressModalOpen(false)}
      mode="browser"
      formData={{
        address: location.browsing_address,
        latitude: location.browsing_lat,
        longitude: location.browsing_lng,
      }}
      setFormData={(data) =>
        setLocation({
          browsing_address: data.address,
          browsing_lat: data.latitude,
          browsing_lng: data.longitude,
        })
      }
    />
  );
};

export default AddressModalContainer;
